import { createColumnHelper } from '@tanstack/react-table';
import { RateOverview } from '@mews-commander/data-access';
import { TextKey } from '@mews-commander/enums';
import { LocalizedText } from '@mews/framework';
import { Tag } from '@optimus-web/core';
import { RowActions } from './RowActions';

const columnHelper = createColumnHelper<RateOverview>();

export const columns = [
    columnHelper.accessor('name', {
        header: () => <LocalizedText textKey={TextKey.Name} />,
    }),
    columnHelper.accessor('baseRateId', {
        header: () => <LocalizedText textKey={TextKey.Type} />,
        cell: (props) => {
            const value = !!props.getValue();
            return (
                <Tag variant={value ? 'basicSubtle' : 'primary'} outline>
                    <LocalizedText textKey={value ? TextKey.DependentRate : TextKey.BaseRate} />
                </Tag>
            );
        },
    }),
    columnHelper.display({
        id: 'actions',
        header: '',
        meta: { align: 'end' },
        cell: (props) => <RowActions rate={props.row.original} setRowSelection={props.table.setRowSelection} />,
    }),
];
